module.exports = __webpack_public_path__ + "static/media/pz3.7a2a464f.png";